const ImportEmptyPlaceholder = () => {
    return <div style={{ marginTop: "28px" }}></div>;
};

export default ImportEmptyPlaceholder;
